import './index.css'; // CRITICAL: This links Tailwind to your components
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css'; 
import App from './App.js'; // Added .js here

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);